let $instance

class PubSub {
  constructor() {
    this.$events = {}
    this.$count = 0
  }

  static getInstance() {
    if (!$instance) {
      $instance = new PubSub()
    }
    return $instance
  }

  emit(event, ...args) {
    if (this.$events[event]) {
      this.$events[event].map((cb) => {
        if (typeof cb === 'function') {
          cb(...args)
        }
      })
    }
  }

  hasSubscribers(event) {
    if (!this.$events[event]) {
      return null
    }
    return this.$events[event].length > 0
  }

  loading(callback) {
    this.$count += 1
    this.subscribe('$loaded', callback)
    this.emit('loading')
  }

  numOfSubscriber(event) {
    if (!this.$events[event]) {
      return 0
    }
    return this.$events[event].length
  }

  loaded() {
    this.$count -= 1
    if (this.$count === 0) {
      this.emit('$loaded')
    }
  }

  subscribe(event, callback) {
    if (!this.$events[event]) {
      this.$events[event] = []
    }
    if (!this.$events[event].includes(callback)) {
      this.$events[event].push(callback)
    }
    return this
  }

  unsubscribe(event, callback) {
    if (this.$events[event]) {
      if (this.$events[event].includes(callback)) {
        const idx = this.$events[event].indexOf(callback)
        this.$events[event] = this.$events[event].splice(idx, 1)
      }
    }
  }

}

export default {
  PubSub
}
export {
  PubSub
}
